var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row__wrapper"},[_c('div',{staticClass:"label"},[_vm._t("label")],2),_c('div',{staticClass:"value"},[_vm._t("value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }